import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { FORM_KEYS } from '@modules/projects/projectsForm/customizeModule/manageMForm/config/form.keys';
import { INPUT_MAP } from '@modules/projects/projectsForm/customizeModule/manageMForm/config/form.config';
import {
  columns,
  defaultColumns,
  flexStyle,
} from '@modules/projects/projectsForm/customizeModule/manageMForm/config/columns.config';
import { nanoid } from 'nanoid';

import { FORM_KEYS as SECTION_FORM_KEYS } from '@modules/projects/integrationHub/manageModules/manageMForm/config/form.keys';
import { INPUT_MAP as SECTION_INPUT_MAP } from '@modules/projects/integrationHub/manageModules/manageMForm/config/form.config';
import { API } from '@service';
import { deepCopy } from '@utils/common';
import { addModuleConfig as defaultAddModuleConfig } from '@modules/projects/integrationHub/manageModules/manageMForm/config/add.config';
import { validateRepeated } from '@components/dragableTableFrom/formItems';
import {
  DisabledRatioSelectorOptions,
  FixedRatios,
  INTEGRATION_TYPES,
  RatioSelectorOptions,
} from '@model';

export const systemModuleColumns = cloneDeep(columns)
  .slice(0, columns.length - 3)
  .concat(
    {
      title: <div className="col-title left pl15">Display</div>,
      dataIndex: FORM_KEYS.INTERNAL.key,
      key: FORM_KEYS.INTERNAL.key,

      formConfig: {
        ...INPUT_MAP[FORM_KEYS.INTERNAL.key],
        // internalPriority: true,
      },
      style: { width: '5rem', ...flexStyle },
    },
    // {
    //   title: (
    //     <div className="col-title left pl15">
    //       <span>{FORM_KEYS.CLIENT.label}</span>
    //     </div>
    //   ),
    //   dataIndex: FORM_KEYS.CLIENT.key,
    //   key: FORM_KEYS.CLIENT.key,
    //   formConfig: {
    //     ...INPUT_MAP[FORM_KEYS.CLIENT.key],
    //     // internalPriority: true,
    //   },
    //   style: { width: '5rem', ...flexStyle },
    // },
    {
      dataIndex: FORM_KEYS.DELETE.key,
      key: FORM_KEYS.DELETE.key,
      style: {
        ...flexStyle,
        width: '1rem',
      },
      formConfig: { ...INPUT_MAP[FORM_KEYS.DELETE.key] },
    },
  );

export const systemModuleDefaultColumns = cloneDeep(defaultColumns)
  .slice(0, defaultColumns.length - 2)
  .concat(
    {
      title: <div className="col-title left pl15">Display</div>,
      dataIndex: FORM_KEYS.INTERNAL.key,
      key: FORM_KEYS.INTERNAL.key,
      formConfig: {
        ...INPUT_MAP[FORM_KEYS.INTERNAL.key],
        // internalPriority: true,
      },
      style: { width: '5rem', ...flexStyle },
    },
    // {
    //   title: (
    //     <div className="col-title left pl15">
    //       <span>{FORM_KEYS.CLIENT.label}</span>
    //     </div>
    //   ),
    //   dataIndex: FORM_KEYS.CLIENT.key,
    //   key: FORM_KEYS.CLIENT.key,
    //   formConfig: {
    //     ...INPUT_MAP[FORM_KEYS.CLIENT.key],
    //     // internalPriority: true,
    //   },
    //   style: { width: '5rem', ...flexStyle },
    // },
  );

const checkBoxStyle = {
  ...flexStyle,
  maxHeight: '6rem',
};

const setRulUnrepeatable = (config) => {
  config.rules = [
    ...config.rules,
    validateRepeated(
      SECTION_FORM_KEYS.SECTION.key,
      null,
      'Duplicate section name(s)',
    ),
  ];
  return config;
};

export const getProjectSectionColumns = (
  isDefault = false,
  showRatio = false,
  // defaultRowNameUneditable = false,
) =>
  [
    {
      title: (
        <div className="col-title">
          <span />
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.DRAG.key,
      key: SECTION_FORM_KEYS.DRAG.key,
      style: { ...checkBoxStyle, width: '3rem' },
      formConfig: { ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.DRAG.key] },
    },
    {
      title: (
        <div className="col-title left pl15">
          <span className="is-required">{SECTION_FORM_KEYS.SECTION.label}</span>
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.SECTION.key,
      key: SECTION_FORM_KEYS.SECTION.key,
      style: { width: '20rem' },
      formConfig: setRulUnrepeatable({
        ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.SECTION.key],
        // disabled: defaultRowNameUneditable,
      }),
    },
    {
      title: (
        <div className="col-title">
          <span>{SECTION_FORM_KEYS.TYPE.label}</span>
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.TYPE.key,
      key: SECTION_FORM_KEYS.TYPE.key,
      style: { ...checkBoxStyle, width: '7rem' },
      formConfig: { ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.TYPE.key] },
    },
    showRatio
      ? {
          title: (
            <div className="col-title">
              <span>{SECTION_FORM_KEYS.RATIO.label}</span>
            </div>
          ),
          dataIndex: SECTION_FORM_KEYS.RATIO.key,
          key: SECTION_FORM_KEYS.RATIO.key,
          style: { ...checkBoxStyle, width: '12.5rem' },
          formConfig: {
            ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.RATIO.key],
            disabled: isDefault,
            options: isDefault
              ? DisabledRatioSelectorOptions
              : RatioSelectorOptions,
            defaultValue: isDefault ? FixedRatios.NONE : FixedRatios.FULL,
            shouldRefRowData: true,
            className: 'section-ratio-select',
          },
        }
      : null,
    {
      title: (
        <div className="col-title left pl15">
          <span>{SECTION_FORM_KEYS.LINK.label}</span>
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.LINK.key,
      key: SECTION_FORM_KEYS.LINK.key,
      style: { width: '21.75rem' },
      formConfig: isDefault
        ? { ...INPUT_MAP[FORM_KEYS.DLINK.key] }
        : {
            ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.LINK.key],
            uploadPDFAPI: API.uploadReportPdf,
            onSectionSetting: true,
          },

      //
    },
    {
      title: (
        <div className="col-title">
          <span>Display</span>
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.DISPLAY.key,
      key: SECTION_FORM_KEYS.DISPLAY.key,
      style: { ...checkBoxStyle, width: '5rem' },
      formConfig: {
        ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.DISPLAY.key],
        shouldNotDisablePowerBI: true,
      },
    },
    isDefault
      ? null
      : {
          dataIndex: SECTION_FORM_KEYS.DELETE.key,
          key: SECTION_FORM_KEYS.DELETE.key,
          style: {
            ...flexStyle,
            width: '1.25rem',
            paddingLeft: 0,
            paddingRight: 0,
          },
          formConfig: {
            ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.DELETE.key],
            alertContent: 'Are you sure you want to delete this module?',
          },
        },
  ].filter((e) => e !== null);

export const getProjectMultiModuleSectionColumns = () =>
  [
    {
      title: (
        <div className="col-title">
          <span />
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.DRAG.key,
      key: SECTION_FORM_KEYS.DRAG.key,
      style: { ...checkBoxStyle, width: '3rem' },
      formConfig: { ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.DRAG.key] },
    },
    {
      title: (
        <div className="col-title">
          <span>{SECTION_FORM_KEYS.SECTION.label}</span>
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.SECTION.key,
      key: SECTION_FORM_KEYS.SECTION.key,
      style: { width: '20rem' },
      formConfig: setRulUnrepeatable({
        ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.SECTION.key],
      }),
    },
    {
      title: (
        <div className="col-title">
          <span>{SECTION_FORM_KEYS.TYPE.label}</span>
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.TYPE.key,
      key: SECTION_FORM_KEYS.MultiType.key,
      style: { ...checkBoxStyle, width: '12.5rem' },
      formConfig: {
        ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.MultiType.key],
        // ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.TYPE.key],
        className: 'section-ratio-select',
        // shouldRefRowData: false,
        // disabled: true,
      },
    },
    {
      title: (
        <div className="col-title">
          <span>{SECTION_FORM_KEYS.RATIO.label}</span>
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.RATIO.key,
      key: SECTION_FORM_KEYS.RATIO.key,
      style: { ...checkBoxStyle, width: '12.5rem' },
      formConfig: {
        ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.RATIO.key],
        options: RatioSelectorOptions,
        defaultValue: FixedRatios.FULL,
        shouldRefRowData: true,
        className: 'section-ratio-select',
      },
    },
    {
      title: (
        <div className="col-title left pl15">
          <span>{SECTION_FORM_KEYS.LINK.label}</span>
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.LINK.key,
      key: SECTION_FORM_KEYS.LINK.key,
      style: { width: '21.75rem' },
      formConfig: {
        ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.LINK.key],
        uploadPDFAPI: API.uploadReportPdf,
        onSectionSetting: true,
      },
    },
    {
      title: (
        <div className="col-title">
          <span>Display</span>
        </div>
      ),
      dataIndex: SECTION_FORM_KEYS.DISPLAY.key,
      key: SECTION_FORM_KEYS.DISPLAY.key,
      style: { ...checkBoxStyle, width: '5rem' },
      formConfig: {
        ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.DISPLAY.key],
        shouldNotDisablePowerBI: true,
      },
    },
    {
      dataIndex: SECTION_FORM_KEYS.DELETE.key,
      key: SECTION_FORM_KEYS.DELETE.key,
      style: {
        ...flexStyle,
        width: '1.25rem',
        paddingLeft: 0,
        paddingRight: 0,
      },
      formConfig: {
        ...SECTION_INPUT_MAP[SECTION_FORM_KEYS.DELETE.key],
        alertContent: 'Are you sure you want to delete this module?',
      },
    },
  ].filter((e) => e !== null);

export const getDefaultRowData = (data = {}) => ({
  // "id": "9CEAEA26-2092-ED11-9D78-6045BD04943A",
  identifier: nanoid(),
  [SECTION_FORM_KEYS.LINK.key]: '',
  // "dataSourceLink": null,
  [FORM_KEYS.TYPE.key]: 'other',
  [FORM_KEYS.DISPLAY.key]: true,
  [SECTION_FORM_KEYS.RATIO.key]:
    data.type && (data.type === 'powerbi' || data.type === 'powerbiModule')
      ? FixedRatios.AUTO
      : FixedRatios.BANNER,
  // [SECTION_FORM_KEYS.IFRAME.key]: false,
  ...data,
});

const addConfig = deepCopy(defaultAddModuleConfig);

addConfig.radios.find((e) => e.typeText === 'Other').value = 'other';

export const addModuleConfig = addConfig;

const configWithOutM365 = deepCopy(addConfig);
configWithOutM365.radios = configWithOutM365.radios.filter(
  (i) => i.value !== INTEGRATION_TYPES.M365,
);

export const systemSettingAddConfig = configWithOutM365;
